import useTranslation from "../../hooks/useTranslation";
import { abreviatePcrText } from "../../helpers/helpers";
import { OptionsRitmoECGCritical, OptionsRitmoECGNormal } from "../../helpers/Constants";

const TimelinePatientRhythm = ({ data, startTime, endTime, abreviation }) => {
  const T = useTranslation();

  const totalDuration = endTime - startTime;
  const evenIntervalsColor = "#A29FA0";
  const oddIntervalColor = "#DAD9DB";

  return (
    <div className="relative w-full h-[70px] mt-6">
      {data.map((item, index) => {
        // Clamp times within timeline bounds
        const clampedStart = Math.max(item.start, startTime);
        const clampedEnd = Math.min(item.end, endTime);

        // Skip if clamped range is invalid
        if (clampedEnd <= clampedStart) return null;

        const itemDuration = clampedEnd - clampedStart;
        const widthPercent = (itemDuration / totalDuration) * 100;
        const leftOffsetPercent =
          ((clampedStart - startTime) / totalDuration) * 100;

        const nameAbr = abreviatePcrText(item.name);
        
        // Verificar si es un ritmo crítico (parada cardíaca)
        const isCriticalRhythm = OptionsRitmoECGCritical.includes(item.name);
        
        // Verificar si estamos en contexto de RCE (ritmos con pulso)
        // Si estamos en RCE, todos los ritmos deben ser verdes
        const isRCEContext = data.some(event => 
          event.name && OptionsRitmoECGNormal.includes(event.name)
        );
        
        const backgroundColor = isRCEContext 
          ? "#2AAC9C" // Verde para todos los ritmos en contexto RCE
          : isCriticalRhythm 
            ? "#F9839A" // Rojo para ritmos de parada en contexto PCR
            : index % 2 === 0 ? evenIntervalsColor : oddIntervalColor;

        return (
          <div
            key={index}
            className="absolute h-2 "
            style={{
              width: `${widthPercent}%`,
              left: `${leftOffsetPercent}%`,
              backgroundColor,
              top: "0",
            }}
          >
            <span
              className="absolute w-full text-center text-gray-800 text-xs font-bold"
              style={{ top: "16px" }}
            >
              {T(nameAbr)}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default TimelinePatientRhythm;
